import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CheckboxCollection from 'components/application/CheckboxCollection';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function PersonnelTypeFilters({
  filters,
  isDisabled,
  onChange,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.PersonnelTypeFilters',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const { singularRAMSName } = currentActor.division.attributes;

  const checkboxes =
    currentActor.isAllowedFeature('training_register_only') ?
      [
        {
          label: i18nTShared('employees'),
          name: 'employeeFilter',
          checked: filters.employeeFilter,
        },
        {
          label: i18nTShared('subcontractors'),
          name: 'subFilter',
          checked: filters.subFilter,
        },
      ]
    : [
        {
          label: i18nTShared('employees'),
          name: 'employeeFilter',
          checked: filters.employeeFilter,
        },
        {
          checked: filters.activeSubFilter,
          label: i18nT('checkboxes.activeSubFilter.label'),
          name: 'activeSubFilter',
          tooltip: i18nT('checkboxes.activeSubFilter.tooltip', {
            interpolation: { escapeValue: false },
            singularRAMSName,
          }),
          tooltipAlignment: 'right',
        },
        {
          checked: filters.inActiveSubFilter,
          label: i18nT('checkboxes.inActiveSubFilter.label'),
          name: 'inActiveSubFilter',
          tooltip: i18nT('checkboxes.inActiveSubFilter.tooltip', {
            interpolation: { escapeValue: false },
            singularRAMSName,
          }),
          tooltipAlignment: 'right',
        },
      ];

  return (
    <CheckboxCollection
      checkBoxes={checkboxes}
      isDisabled={isDisabled}
      labelTextProps={{ className: 'tw-font-medium' }}
      mustSelect={true}
      onChange={onChange}
    />
  );
}

PersonnelTypeFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

PersonnelTypeFilters.defaultProps = {
  isDisabled: false,
};
